'use client'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslations } from 'next-intl'
import { useTranslatedQueryHandling } from '@/hooks/use-translated-query-handling'
import { selectKnowledgeSourceFilesAction, syncKnowledgeSourceAction, removeKnowledgeSourceItemAction, assignKnowledgeSourceFolderAction, disconnectKnowledgeSourceAction } from '@/server-actions/knowledge-sources'
import { knowledgeSourcesQueryKey } from '@/hooks/queries/knowledge-sources'

export function useKnowledgeSourceMutation() {
  const withQueryHandling = useTranslatedQueryHandling()
  const queryClient = useQueryClient()
  const t = useTranslations('KnowledgeSources')
  return useMutation({
    mutationFn: async (input:
      | { kind: 'select'; values: Parameters<typeof selectKnowledgeSourceFilesAction>[0]; setErrors?: (errors: Record<string, unknown>) => void }
      | { kind: 'sync'; folderId: string }
      | { kind: 'disconnect'; connectionId: string }
      | { kind: 'remove'; itemId: string }
      | { kind: 'assign'; folderId: string; agent: { type: 'voice' | 'email' | 'message'; id: string }; assign: boolean }) => {
      const options = { loading: t('saving'), success: t('saved') }
      switch (input.kind) {
        case 'select': return withQueryHandling(selectKnowledgeSourceFilesAction(input.values), { ...options, setErrors: input.setErrors })
        case 'disconnect': return withQueryHandling(disconnectKnowledgeSourceAction({ connectionId: input.connectionId }), options)
        case 'sync': return withQueryHandling(syncKnowledgeSourceAction({ folderId: input.folderId }), options)
        case 'remove': return withQueryHandling(removeKnowledgeSourceItemAction({ itemId: input.itemId }), options)
        case 'assign': return withQueryHandling(assignKnowledgeSourceFolderAction(input), options)
      }
    },
    onSuccess: async () => {
      await Promise.all([queryClient.invalidateQueries({ queryKey: knowledgeSourcesQueryKey }), queryClient.invalidateQueries({ queryKey: ['knowledge-base'] })])
    },
  })
}
